import z from "zod";
import { Country } from "./enums/Country";
import { OpeningHoursScheme } from "./openingHours";

export const OnlineOrderSettingsDBScheme = z.object({
  enabled: z.boolean(),
  logo: z.string().nullable().optional(),
  footerIntroText: z.string().nullable().optional(),

  street: z.string().nullable().optional(),
  postalcode: z.string().nullable().optional(),
  city: z.string().nullable().optional(),
  country: z.enum(Country).nullable().optional(),
  phone: z.string().nullable().optional(),
  email: z.string().nullable().optional(),

  websiteUrl: z.string().nullable().optional(),
  termsText: z.string().nullable().optional(),
  privacyPolicyText: z.string().nullable().optional(),
  openingHours: OpeningHoursScheme.nullable().optional(),
  openingHoursNote: z.string().nullable().optional(),

  displayedDeliveryDurationMinutes: z
    .number()
    .int()
    .nonnegative()
    .nullable()
    .optional(),

  primaryColor: z.string().nullable().optional(),
  primaryContrastColor: z.string().nullable().optional(),
  backgroundColor: z.string().nullable().optional(),
  lightTextColor: z.string().nullable().optional(),
  lightMutedTextColor: z.string().nullable().optional(),
  darkTextColor: z.string().nullable().optional(),
  darkMutedTextColor: z.string().nullable().optional(),
  navbarBackgroundColor: z.string().nullable().optional(),
  footerBackgroundColor: z.string().nullable().optional(),
  darkMode: z.boolean().optional(),

  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export type OnlineOrderSettings = z.infer<typeof OnlineOrderSettingsDBScheme>;

export const RestUpdateOnlineOrderSettings = OnlineOrderSettingsDBScheme.omit({
  createdAt: true,
  updatedAt: true,
}).partial();

export type RestUpdateOnlineOrderSettings = z.infer<
  typeof RestUpdateOnlineOrderSettings
>;
